module.exports = __webpack_public_path__ + "img/syngenta-icon.b4c95b7e.png";